import ModalTitle from "@components/modal/ModalTitle";
import { Trans } from "@lingui/macro";
import { Box, DialogContent, Skeleton } from "@mui/material";
import { type FC } from "react";

export const Fallback: FC<{ onClose: () => void }> = ({ onClose }) => (
  <>
    <ModalTitle
      onClose={onClose}
      title={
        <Box display="flex" gap={1}>
          <Trans>Gráfico de reportes DGA</Trans> <Skeleton variant="text" width={200} />
        </Box>
      }
    />
    <DialogContent dividers>
      <Skeleton variant="rounded" height={500} />
    </DialogContent>
  </>
);
